import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-circle-close2",
  "use": "icon-circle-close2-usage",
  "viewBox": "0 0 27 27",
  "content": "<symbol viewBox=\"0 0 27 27\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-circle-close2\">\n<circle cx=\"13.5\" cy=\"13.5\" r=\"13.5\" fill=\"#373737\" fill-opacity=\"0.5\" />\n<rect x=\"7\" y=\"19.0205\" width=\"17\" height=\"2\" rx=\"1\" transform=\"rotate(-45 7 19.0205)\" fill=\"#E3F2FF\" />\n<rect width=\"17\" height=\"2\" rx=\"1\" transform=\"matrix(-0.707107 -0.707107 -0.707107 0.707107 20.4355 19.0205)\" fill=\"#E3F2FF\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol